// extracted by mini-css-extract-plugin
export var dropdownButton = "_15-0";
export var fullWidthDropdownButton = "_15-1";
export var icon = "_15-3";
export var iconPlaceholder = "_15-2";
export var menuItemRow = "_15-9";
export var separator = "_15-e";
export var shortcutContainer = "_15-7";
export var shortcutContainerFilled = "_15-8";
export var shortcutIconLg = "_15-6";
export var shortcutIconMd = "_15-5";
export var shortcutIconSm = "_15-4";
export var submenuChevron = "_15-d";
export var submenuDropdown = "_15-a";
export var submenuTriggerRow = "_15-b";
export var submenuTriggerRowOpen = "_15-c";